// extracted by mini-css-extract-plugin
export default {"overlay":"w8nvPKlV"};